// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PtMLe","col":"styles_col__JVbzN","actions":"styles_actions__3nTYY","conflict":"styles_conflict__1Gfnw"};